// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__15e1p","description":"PatientConsentPreview_description__3Fq20"};